import { Link, useLocation } from 'react-router-dom';
import { Logo } from '../components/Logo';

export const VerifyPage = () => {
  const loc = useLocation();
  const email = (loc.state as { email?: string } | null)?.email;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Logo className="text-center mb-6" />
        <div className="card text-center space-y-4">
          <div className="mx-auto w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-2xl">
            ✉
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-2">verifique seu email</h2>
            <p className="text-sm text-navy-600">
              enviamos um link mágico para
              {email ? (
                <span className="block font-mono text-navy-900 mt-1">{email}</span>
              ) : (
                ' o email cadastrado.'
              )}
            </p>
          </div>
          <div className="text-sm text-navy-500 space-y-2 pt-2 border-t border-navy-100">
            <p>o link expira em 30 minutos.</p>
            <p>não esquece de checar o spam.</p>
          </div>
          <Link to="/login" className="btn-ghost text-sm">
            enviar novo link
          </Link>
        </div>
        <p className="text-center text-xs text-navy-500 mt-6">by lions intelligence</p>
      </div>
    </div>
  );
};
